import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';
import nds from '@nerdwallet/base-styles/classes';
import { Type } from '@nerdwallet/currency';

import { stringInputSpec } from '../../lib/editing-configs';
import { getQueryParams } from '../../lib/query-param-helpers';
import { isInBuilder } from '../../lib/helpers';
// TODO: fix import cycle
// eslint-disable-next-line import/no-cycle
import { alwaysRenderInBuilder } from '../builder/actions';

const QueryParamSection = ({
  children,
  history,
  queryToWatch,
  requiredQueryValue,
  watchQueryParamsInBuilder,
}) => {
  // in the builder we may want to just display all QueryParamSections for editing purpose
  // if we're in builder and have not been told to watch query params, render without checking query params
  if (
    isInBuilder(get(history, 'location.pathname')) &&
    !watchQueryParamsInBuilder
  ) {
    return <div>{children}</div>;
  }

  const queryParams = getQueryParams(history);
  const currentQueryValue = get(queryParams, queryToWatch, '');

  if (currentQueryValue === requiredQueryValue) {
    return <div>{children}</div>;
  }
  return null;
};

QueryParamSection.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object,
  queryToWatch: PropTypes.string,
  requiredQueryValue: PropTypes.string,
  watchQueryParamsInBuilder: PropTypes.bool,
};

QueryParamSection.defaultProps = {
  children: [],
  queryToWatch: '',
  requiredQueryValue: '',
};

QueryParamSection.description =
  'Use the "Insert Child" functionality in the "Build" tab to add components that will display only when this query param is present. To control visibility in the builder, check out the Page component.';

QueryParamSection.getEditingConfig = () => [
  stringInputSpec('queryToWatch', 'Query Param Name', {
    help: 'The query parameter to watch. E.g., if you want to show this section when category=travel, this should be category.',
  }),
  stringInputSpec('requiredQueryValue', 'Query Param Value', {
    help: 'The query value that will make this section appear. E.g., if you want to show this section when category=travel, this should be travel.',
  }),
];

QueryParamSection.isContainer = true;

QueryParamSection.alternativeBuilderDisplay = (dispatch, node) => {
  const queryToWatch = get(node, 'props.queryToWatch');
  const requiredQueryValue = get(node, 'props.requiredQueryValue');
  return (
    <Type
      size={2}
      className={nds('padding-all-4', 'text-align-center')}
      onClick={() => dispatch(alwaysRenderInBuilder(node.id))}
    >
      This component displays with the query string
      <Type inline bold>
        {` ${queryToWatch}=${requiredQueryValue}`}
      </Type>
      . It&apos;s hidden right now, but you can click to load it!
    </Type>
  );
};

export default compose(
  withRouter,
  connect(
    createStructuredSelector({
      watchQueryParamsInBuilder: property('builder.watchQueryParams'),
    })
  )
)(QueryParamSection);
